<template>
  <div>
    <div class="payment-status" style="left:0px;margin-left:auto;" v-cloak v-if="orderInfo.status">
      <!--失败时: 用icon-iconfontguanbi fail替换icon-duihao2 bg-color-red-->
      <div class="iconfont icon-duihao2 bg-color-red" v-if="orderInfo.status=='02'"></div>
      <div class="iconfont icon-iconfontguanbi fail" v-else></div>
      <!-- 失败时:订单支付失败 -->
      <div class="status" v-if="orderInfo.status=='02'">Recharge succeeded</div>
      <div class="status" v-else>Recharge fail</div>

      <div class="wrapper">
        <div class="item acea-row row-between-wrapper">
          <div>Order No.</div>
          <div class="itemCom" v-text="orderInfo.outTradeNo"></div>
        </div>
        <!-- <div class="item acea-row row-between-wrapper">
        <div>Order time</div>
        <div class="itemCom" v-text="orderInfo.tradePayTime"></div>
      </div> -->
        <!-- <div class="item acea-row row-between-wrapper">
        <div>Payment Method</div>
        <div class="itemCom" v-if="orderInfo.pay_type == 'yue'">Pay via balance</div>
        <div class="itemCom" v-else>Other</div>
      </div> -->
        <div class="item acea-row row-between-wrapper">
          <div>Total Amount</div>
          <div class="itemCom">{{icon_moeny}}{{orderInfo.amount | MoneyFormat}}</div>
        </div>
        <!--失败时加上这个  -->
        <div class="item acea-row row-between-wrapper" v-if="orderInfo.status != '02'">
          <div>failure reason</div>
          <div class="itemCom" v-text="orderInfo.errCode"></div>
        </div>
      </div>



      <div>
        <div class="returnBnt  bg-color-red" @click="goPages('/')">Back home</div>
      </div>
    </div>

    <!-- 缺少参数 -->
    <div class="payment-status" style="left:0px;margin-left:auto;" v-cloak
      v-if="!orderid || orderInfo.returnCode==='1'">
      <!--失败时: 用icon-iconfontguanbi fail替换icon-duihao2 bg-color-red-->
      <div class="iconfont icon-iconfontguanbi fail"></div>
      <!-- 失败时:订单支付失败 -->

      <div class="status">Recharge query fail</div>

      <div class="wrapper">

        <div class="item acea-row row-between-wrapper" v-if="orderInfo.status != '02'">
          <div>failure reason</div>
          <div class="itemCom">Recharge callback orderNo is not exist</div>
        </div>
      </div>



      <div>
        <div class="returnBnt  bg-color-red" @click="goPages('/')">Back home</div>
      </div>
    </div>

  </div>
</template>
<script>

  const NAME = "RechargeStatus";
  import { recharge_callback } from "@/api/user";


  export default {
    name: NAME,
    props: {},
    data: function () {
      return {
        icon_moeny: this.global.moeny,
        orderid: '',
        orderInfo: {}

      };
    },
    watch: {
      $route(n) {

        if (n.name === NAME && this.id !== n.params.id) {
          this.orderid = this.getQueryVariable('orderNo')
          this.queryOrder()
        }
      }
    },
    computed: {

    },
    mounted() {
      this.orderid = this.getQueryVariable('orderNo')
      //  console.log("orderid",this.getQueryVariable('orderNo'))
      this.queryOrder()
    },
    methods: {
      queryOrder() {
        if (!this.orderid) {
          this.$dialog.error("Error:orderNo is not exist!")
          return
        }

        recharge_callback({ outTradeNo: this.orderid }).then(res => {
          // console.log('res====>',res)

          this.orderInfo = res.data
        })
      },
      getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
      },
      goPages(url) {
        this.$router.push({ path: url })
      }
    }
  };
</script>